import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  InputText,
  Spacer,
  LinkIcon,
  LocationAutocompleteInput,
  PhoneNumber,
  Text,
} from '@myinterview/component-library';
import { UploadInput } from './common/UploadInput';
import { IParsedInputField } from '../interfaces/jobInterface';
import { getFileNameFromS3Url } from '../utils/utils';
import { IInputFields } from '../interfaces';

interface IProps {
  inputFieldsData: IParsedInputField;
  jobInputFields: IInputFields[];
  handleInputField: (data: { value: string, type: string, name: string }) => void;
}
export const Form = ({ inputFieldsData, jobInputFields, handleInputField }: IProps) => {
  const { t } = useTranslation();
  const onInputValue = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    const { value, type, name } = target;
    handleInputField({ value, type, name });
  };
  const renderField = (field: IInputFields) => {
    const isRtl = document.documentElement.getAttribute('data-direction') === 'rtl';
    if (field.type === 'document') {
      const initialFileName = getFileNameFromS3Url(inputFieldsData[field.fieldName]?.value || '');
      return (
        <UploadInput
          rtl={isRtl}
          browseText={t('form.browse')}
          uploadingText={t('form.uploading')}
          dropHereText={t('form.dropHere')}
          field={field}
          onUploadDoc={handleInputField}
          initialFileName={initialFileName}
        />
      );
    }
    if (['url', 'text'].includes(field.type)) {
      return (
        <InputText
          placeholder={field.label}
          icon={<LinkIcon />}
          type={field.type}
          onInput={onInputValue}
          name={field.fieldName}
        />
      );
    }
    if (field.type === 'location') {
      return (
        <LocationAutocompleteInput
          rtl={isRtl}
          onSelectItem={(val) => handleInputField({
            value: val as string,
            type: field.type,
            name: field.fieldName,
          })}
          options={[]}
          hideArrow
          clearable
          placeholder={t('form.searchAddress')}
          searchDebounce={500}
        />
      );
    }
    if (field.type === 'phoneNumber') {
      return (
        <PhoneNumber
          rtl={isRtl}
          placeholder={t('form.phoneNumber')}
          onPhoneInput={(val: string) => { handleInputField({ value: val, type: 'phoneNumber', name: 'phoneNumber' }); }}
        />
      );
    }
    return <InputText type={field.type} onInput={onInputValue} name={field.fieldName} />;
  };
  return (
    <>
      {jobInputFields.filter((f) => f.fieldName === 'cvUrl').map((field: IInputFields) => (
        <div key={field.fieldName}>
          {renderField(field)}
        </div>
      ))}
      {!!jobInputFields.filter((f) => f.fieldName !== 'cvUrl').length && (
        <>
          <Spacer y={1.5} />
          <div className="optional-section dynamic-direction">
            <Text>{t('form.optional')}</Text>
            <span className="optional-section__separator" />
          </div>
        </>
      )}
      <Spacer y={1.5} />
      {jobInputFields.filter((f) => f.fieldName !== 'cvUrl').map((field: IInputFields) => (
        <div key={field.fieldName}>
          {renderField(field)}
          <Spacer y={1} />
        </div>
      ))}
    </>
  );
};
